import React, { useEffect, useRef, useState } from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import Marquee from 'react-fast-marquee';
import { colors } from 'constants/colors';

const TextBarContainer = styled(Grid)(() => ({
  position: 'relative',
  width: '100%',
  height: '30px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
}));

const TextContainerInline = styled(Grid)(() => ({
  display: 'inline-block',
}));

const TextPink = styled('span')({
  color: colors.default.secondary,
});
const TextSpan = styled('span')({
  display: 'flex',
  gap: '5px',
  alignItems: 'center',
  marginRight:'5px',
  fontFamily: 'Modak',
  fontSize: '20px',
  lineHeight: '30px',
  letterSpacing: '4.5%',
});

const StyledClockIcon = styled(AccessTimeIcon)({
  color: colors.default.info,
  fontSize: 'inherit',
  transform: 'translateY(-10%)',
});

interface MarqueeTextBarProps {
  pinkText: string;
  text: string;
  icon?: boolean;
}

export const MarqueeTextBar = ({
  pinkText,
  text,
  icon = false,
}: MarqueeTextBarProps) => {
  const [repetionsArray, setRepetitionsArray] = useState<number[] | null>();
  const barRef = useRef<HTMLDivElement | null>(null);
  const textRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const bar = barRef.current;
    const textElement = textRef.current;

    if (bar && textElement) {
      const availableWidth = bar.clientWidth;
      const textWidth = textElement.clientWidth;
      const repetitions = availableWidth / textWidth;
      setRepetitionsArray(Array.from({ length: repetitions + 1 }, (v, i) => i));
    }
  }, []);

  return (
    <TextBarContainer ref={barRef}>
      {repetionsArray ? (
        <Marquee style={{position:'absolute'}}>
          {repetionsArray?.map((repeat) => (
            <TextSpan key={repeat}>
              {icon && <StyledClockIcon />}
              <TextPink>{pinkText}</TextPink>
              <Typography
                fontSize="inherit"
                className="Modak color-transparent"
              >
                {text}
              </Typography>
            </TextSpan>
          ))}
        </Marquee>
      ) : (
        <TextContainerInline ref={textRef}>
          {pinkText} {text}
        </TextContainerInline>
      )}
    </TextBarContainer>
  );
};

export default MarqueeTextBar;
